// extracted by mini-css-extract-plugin
export default {"form":"PopupUpdateArticle_form__cvBZ6","buttons":"PopupUpdateArticle_buttons__Jo3Y8"};